import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles({
  container: {
    backgroundColor: '#DFDFDE',
  },
  children: {
    maxWidth: '1280px',
    width: '100%',
    vw: '100%',
    margin: 'auto',
  },
});
